export const authPaths = {
  login: '/login',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
};

export const iframePaths = {
  paymentConfirmation: '/payment-confirmation',
  ibConnection: '/ib',
};

export const queryParamPaths = {
  noHeader: '?header=no-header',
};

export const appPaths = {
  base: '/',
  app: '/app',
  questionnaire: '/questionnaire',
  suggestion: '/suggestion',
  explore: '/explore',
  portfolio: '/portfolio',
  myToggle: '/my-toggle',
  myAccount: {
    base: '/my-account',
    portfolio: '/my-account/portfolio',
    subscription: '/my-account/subscription',
    watchlist: '/my-account/watchlist',
    security: '/my-account/security',
    appearance: '/my-account/appearance',
  },
  aiChat: '/app/ai-chat',
  article: '/article',
  upgrade: '/upgrade',
  analyze: '/analyze',
};

export const featurePaths = {
  chartv2: '/app/chart-v2',
};

export const NO_HEADER_PATHS = [
  ...Object.values(iframePaths),
  ...Object.values(authPaths),
];

export const NO_HEADER_PARAMS = [...Object.values(queryParamPaths)];

export const QUESTIONNAIRE_SUGGESTION_PATHS = [
  appPaths.questionnaire,
  appPaths.suggestion,
];

export const NO_IOS_BANNER_PATHS = [
  ...QUESTIONNAIRE_SUGGESTION_PATHS,
  ...NO_HEADER_PATHS,
];
